module.exports = __webpack_public_path__ + "static/media/0023_LES_ENSEIGNES_LE_CHARCUTIER_SCRABBLE.2a7e643b.png";